import { render, staticRenderFns } from "./viewSupportEnquiry.vue?vue&type=template&id=0a5b1d4b&scoped=true&"
import script from "./viewSupportEnquiry.vue?vue&type=script&lang=js&"
export * from "./viewSupportEnquiry.vue?vue&type=script&lang=js&"
import style0 from "./viewSupportEnquiry.vue?vue&type=style&index=0&id=0a5b1d4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5b1d4b",
  null
  
)

export default component.exports